import axios from "axios";
import { CLEAR_OFFICER_PROFILE, GET_OFFICER_PROFILE, LOGIN_FAILURE, LOGIN_SUCCESS, LOGOUT } from "../actionType";
import { toast } from "react-toastify";

export const loginSuccess = (token, user) => ({
    type: LOGIN_SUCCESS,
    payload: { token, user },
});

export const loginFailure = () => ({
    type: LOGIN_FAILURE,
});

export const logout = async (dispatch) => {
    try{
        dispatch({ type: LOGOUT });
        
        toast.success("User logged out");
        
        sessionStorage.removeItem('tokens');
        sessionStorage.removeItem('isAuthenticated');
        sessionStorage.removeItem('officer');
        sessionStorage.removeItem('remember_me');

        localStorage.removeItem('tokens');
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('officer');
        localStorage.removeItem('remember_me');

        sessionStorage.removeItem('applicationFilters');
        sessionStorage.removeItem('applicationStageFilters');
        sessionStorage.removeItem('applicationTrancheLimit');
        sessionStorage.removeItem('branchApplicationFilters');
        sessionStorage.removeItem('leadFilters');
        sessionStorage.removeItem('currentPage');
        sessionStorage.removeItem('leadsCurrentPage');
        sessionStorage.removeItem('leadLimit');
        sessionStorage.removeItem('leadsTotalCount');
        sessionStorage.removeItem('leadsTotalPages');
        sessionStorage.removeItem('limit');
        sessionStorage.removeItem('totalCount');
        sessionStorage.removeItem('totalPages');
        sessionStorage.removeItem('rejectedApplicationFilters');

        sessionStorage.removeItem("taskDashboardState");
        sessionStorage.removeItem("deletedApplicationFilters");

        sessionStorage.removeItem("allRolesLimit");
        sessionStorage.removeItem("officerFilters");
        sessionStorage.removeItem("roleFilters");
        sessionStorage.removeItem("fromRoute");

        // Reset sidebar state to collapsed on logout
        localStorage.setItem('sidebar_expanded', 'false');

        // Clear officer profile so previous officer's permission set 
        // doesn't pick up stale data into the next login
        dispatch({ type: CLEAR_OFFICER_PROFILE });

        return true;
    }
    catch(err){
        toast.error("Logout failed");
        return false;
    }
};

// Thunk for async login with 'remember' parameter for persistent session
export const login = (email, password, remember = false) => async (dispatch) => {
    try {
        const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/officer/login/password`, { email, password });

        if(res.data?.data){
            const { tokens, officer } = res.data.data;

            // Access denied if officer has no permissions at all
            if (!officer?.permissions?.length) {
                toast.error("Access Denied");
                return null;
            }

            dispatch(loginSuccess(tokens.token, officer));

            // Immediately hydrate the profile + officer permission set in Redux
            dispatch({ type: GET_OFFICER_PROFILE, payload: officer });

            toast.success("Login successful");
    
            localStorage.setItem('sidebar_expanded', 'false');

            // Always populate sessionStorage for active tab API calls
            sessionStorage.setItem('tokens', JSON.stringify(tokens));
            sessionStorage.setItem('officer', JSON.stringify(officer));
            sessionStorage.setItem('isAuthenticated', JSON.stringify(true));
            sessionStorage.setItem('remember_me', JSON.stringify(remember));

            if (remember) {
                // Save to localStorage so session persists across tab/browser restarts
                localStorage.setItem('tokens', JSON.stringify(tokens));
                localStorage.setItem('officer', JSON.stringify(officer));
                localStorage.setItem('isAuthenticated', JSON.stringify(true));
                localStorage.setItem('remember_me', JSON.stringify(true));
            } else {
                localStorage.removeItem('tokens');
                localStorage.removeItem('officer');
                localStorage.removeItem('isAuthenticated');
                localStorage.removeItem('remember_me');
            }

            return officer;
        }
    }
    catch (error) {
        console.error('Login failed:', error);

        let errorMsg = error?.response?.data?.message;

        dispatch(loginFailure());
        toast.error(`${errorMsg}`);

        return null;
    }
};
